(function () {
  if (window.vendemmia_wine_club_customizations_loaded) {
    return;
  }

  window.vendemmia_wine_club_customizations_loaded = true;

  var selector = '.wine-subscription-app';
  var default_config = {
    default_minimum_quantity: '6',
    heading_template: 'Choose {minimum} wines to customise your pack.',
    app_intro_text: "<p>Not sure where to start? No worries — Larry has put together a collection of Cherubino essentials, the <em>Vendemmia Six Pack</em> — the wines he'd want in your hands first.</p>",
    app_intro_note: '<p><em>You can adjust your selection any time up to two weeks before dispatch.</em></p>',
    feature_logo_url: 'https://cdn.shopify.com/s/files/1/0652/7739/5059/files/vendemmia_logo_1_transparent.png?v=1779866010',
    feature_logo_alt: 'Vendemmia',
    feature_description: "Larry's curated selection of Cherubino essentials - the wines he'd want in your hands first.",
    review_intro: 'Take a moment to check your selection - you can go back and adjust if needed. Your full address and payment details are on the next page.',
    review_form_intro: '<p>Let us know your birthday so we can send your <strong>annual $50 gift voucher</strong> - and add any delivery notes for your wine pack below.</p>',
    staff_label: 'Recommended by a staff member? Select their name.',
    accent_color: '#b8742a',
    enabled_button_color: '#aa7824',
    page_background_color: '#efefea',
    steps_gap_desktop: 50,
    steps_gap_mobile: 50,
    feature_logo_size: 178,
    feature_logo_offset_y: -12
  };
  var default_minimum_quantity = '6';
  var heading_template = default_config.heading_template;
  var feature_logo_url = default_config.feature_logo_url;
  var feature_logo_alt = default_config.feature_logo_alt;
  var app_intro_text = default_config.app_intro_text;
  var app_intro_note = default_config.app_intro_note;
  var feature_description = "Larry's curated selection of Cherubino essentials - the wines he'd want in your hands first.";
  var review_intro = default_config.review_intro;
  var review_form_intro = default_config.review_form_intro;
  var staff_label = default_config.staff_label;
  var filter_labels = ['All', 'Red', 'White', 'Rosé', 'Sparkling'];
  var has_warned_about_config = false;
  var has_warned_about_selector_change = false;
  var customizations_have_started = false;

  var quantity_required_selectors = [
    '.wh-global-picker .tw-grid.tw-flex-1',
    '.wh-filter-bar',
    '.wh-product-card-container',
    '.wh-product-card-content-title',
    '.wh-product-card-content-container',
    '.wh-product-card-content-qtd-decrease',
    '.wh-product-card-content-qtd-increase',
    '.wh-product-card-content-qtd-input',
    '.wh-product-card-content-price'
  ];

  var review_required_selectors = [
    '.wh-review-order',
    '.wh-review-retail',
    '.wh-review-selling-plan',
    '.wh-review-wines',
    '.wh-pack-cost',
    '.wh-button-primary'
  ];

  function refresh_config() {
    var config_element = document.querySelector('[data-vendemmia-wineclub-config]');
    var section_config = null;

    if (!config_element) {
      return false;
    }

    try {
      section_config = JSON.parse(config_element.textContent);
      has_warned_about_config = false;
    } catch (error) {
      if (!has_warned_about_config) {
        console.warn('[Vendemmia wine club] Custom styling has been disabled because the section settings JSON is invalid.', error);
        has_warned_about_config = true;
      }

      return false;
    }

    default_minimum_quantity = get_config_string(section_config, 'default_minimum_quantity', default_config.default_minimum_quantity).toString();
    heading_template = get_config_string(section_config, 'heading_template', default_config.heading_template);
    app_intro_text = get_config_string(section_config, 'app_intro_text', default_config.app_intro_text);
    app_intro_note = get_config_string(section_config, 'app_intro_note', default_config.app_intro_note);
    feature_logo_url = get_config_string(section_config, 'feature_logo_url', default_config.feature_logo_url);
    feature_logo_alt = get_config_string(section_config, 'feature_logo_alt', default_config.feature_logo_alt);
    feature_description = get_config_string(section_config, 'feature_description', default_config.feature_description);
    review_intro = get_config_string(section_config, 'review_intro', default_config.review_intro);
    review_form_intro = get_config_string(section_config, 'review_form_intro', default_config.review_form_intro);
    staff_label = get_config_string(section_config, 'staff_label', default_config.staff_label);

    document.body.style.setProperty('--vendemmia-gold', get_config_string(section_config, 'accent_color', default_config.accent_color));
    document.body.style.setProperty('--vendemmia-enabled-button', get_config_string(section_config, 'enabled_button_color', default_config.enabled_button_color));
    document.body.style.setProperty('--vendemmia-page-background', get_config_string(section_config, 'page_background_color', default_config.page_background_color));
    document.body.style.setProperty('--vendemmia-steps-gap-desktop', get_config_pixel_value(section_config, 'steps_gap_desktop', default_config.steps_gap_desktop));
    document.body.style.setProperty('--vendemmia-steps-gap-mobile', get_config_pixel_value(section_config, 'steps_gap_mobile', default_config.steps_gap_mobile));
    document.body.style.setProperty('--vendemmia-feature-logo-size', get_config_pixel_value(section_config, 'feature_logo_size', default_config.feature_logo_size));
    document.body.style.setProperty('--vendemmia-feature-logo-offset-y', get_config_pixel_value(section_config, 'feature_logo_offset_y', default_config.feature_logo_offset_y));

    return true;
  }

  function get_config_string(section_config, key, fallback) {
    var value = section_config[key];

    if (typeof value === 'number') {
      return value.toString();
    }

    if (typeof value !== 'string') {
      return fallback;
    }

    value = value.trim();

    if (!value || value === '<p></p>' || value === '<p><br></p>') {
      return fallback;
    }

    return value;
  }

  function get_config_pixel_value(section_config, key, fallback) {
    var value = parseFloat(section_config[key]);

    if (isNaN(value)) {
      value = fallback;
    }

    return value + 'px';
  }

  function set_html_if_changed(element, html) {
    if (element && element.innerHTML.trim() !== html.trim()) {
      element.innerHTML = html;
    }
  }

  function enhance_wine_club() {
    var app = document.querySelector(selector);

    if (!refresh_config()) {
      if (app) {
        disable_customizations(app);
      }

      return;
    }

    if (!app) {
      return;
    }

    if (!can_apply_customizations(app)) {
      return;
    }

    document.body.classList.add('vendemmia-customizations-ready');
    app.classList.add('vendemmia-enhanced');
    suppress_newsletter_popup();
    fix_hidden_newsletter_popup();
    enhance_review_page(app);
    enhance_app_intro(app);
    enhance_page_intro(app);

    var grid = app.querySelector('.wh-global-picker .tw-grid.tw-flex-1');
    var filter_bar = app.querySelector('.wh-filter-bar');

    if (filter_bar && grid && !app.querySelector('.vendemmia-visual-filters')) {
      var filters = document.createElement('div');
      filters.className = 'vendemmia-visual-filters';
      filters.setAttribute('aria-label', 'Wine type filters');

      filter_labels.forEach(function (label, index) {
        var pill = document.createElement('span');
        pill.className = 'vendemmia-filter-pill';
        pill.textContent = label;

        if (index === 0) {
          pill.classList.add('is-active');
        }

        filters.appendChild(pill);
      });

      grid.parentNode.insertBefore(filters, grid);
    }

    var product_cards = app.querySelectorAll('.wh-product-card-container');
    var feature_card = product_cards[0];
    if (!feature_card) {
      return;
    }

    feature_card.classList.add('vendemmia-feature-card');
    enhance_feature_logo(feature_card);

    var title_element = feature_card.querySelector('.wh-product-card-content-title');
    if (!title_element) {
      return;
    }

    if (!title_element.dataset.originalTitle) {
      title_element.dataset.originalTitle = title_element.textContent.trim();
      title_element.setAttribute('title', title_element.dataset.originalTitle);
    }

    var product_title = title_element.dataset.originalTitle.split('|')[0].trim();
    if (product_title && title_element.textContent.trim() !== product_title) {
      title_element.textContent = product_title;
    }

    var content_container = feature_card.querySelector('.wh-product-card-content-container');
    if (!content_container) {
      return;
    }

    var description = content_container.querySelector('.vendemmia-feature-description');
    if (!description) {
      description = document.createElement('div');
      description.className = 'vendemmia-feature-description';
      content_container.insertBefore(description, content_container.firstChild);
    }

    if (description.textContent.trim() !== feature_description) {
      description.textContent = feature_description;
    }

    if (!content_container.querySelector('.vendemmia-feature-list')) {
      var original_title = title_element.dataset.originalTitle || '';
      var wine_list = original_title.split('|').slice(1).join('|').trim();

      if (wine_list) {
        var list = document.createElement('div');
        list.className = 'vendemmia-feature-list';
        list.textContent = wine_list;
        content_container.appendChild(list);
      }
    }
  }

  function enhance_feature_logo(feature_card) {
    var logo_image = feature_card.querySelector('.wh-product-card-image-container img');
    if (!logo_image) {
      return;
    }

    if (logo_image.dataset.originalSrc === undefined) {
      logo_image.dataset.originalSrc = logo_image.getAttribute('src') || '';
      logo_image.dataset.originalSrcset = logo_image.getAttribute('srcset') || '';
      logo_image.dataset.originalSizes = logo_image.getAttribute('sizes') || '';
      logo_image.dataset.originalAlt = logo_image.getAttribute('alt') || '';
    }

    logo_image.classList.add('vendemmia-feature-logo');
    logo_image.setAttribute('src', feature_logo_url);
    logo_image.setAttribute('alt', feature_logo_alt);
    logo_image.removeAttribute('srcset');
    logo_image.removeAttribute('sizes');
  }

  function enhance_app_intro(app) {
    var steps = app.querySelector('.wh-bubble-steps');
    var review_page = app.querySelector('.wh-review-page');
    var existing_intro = app.querySelector('.vendemmia-app-intro');
    var minimum_quantity = get_minimum_quantity(app);

    if (review_page) {
      if (existing_intro) {
        existing_intro.remove();
      }

      return;
    }

    if (!steps) {
      return;
    }

    if (!existing_intro) {
      existing_intro = document.createElement('div');
      existing_intro.className = 'vendemmia-app-intro';
      existing_intro.innerHTML =
        '<h2></h2>' +
        '<div class="vendemmia-app-intro-text"></div>' +
        '<div class="vendemmia-app-intro-note"></div>';

      steps.insertAdjacentElement('afterend', existing_intro);
    }

    var app_heading = existing_intro.querySelector('h2');
    var intro_text = existing_intro.querySelector('.vendemmia-app-intro-text');
    var intro_note = existing_intro.querySelector('.vendemmia-app-intro-note');
    var intro_heading = get_intro_heading(minimum_quantity);

    existing_intro.dataset.minimumQuantity = minimum_quantity;
    set_html_if_changed(intro_text, app_intro_text);
    set_html_if_changed(intro_note, app_intro_note);

    if (app_heading && app_heading.textContent.trim() !== intro_heading) {
      app_heading.textContent = intro_heading;
    }
  }

  function enhance_page_intro(app) {
    var heading = document.querySelector('[id$="__rich_text_ge849y"] .rich-text__heading');
    if (!heading) {
      return;
    }

    var intro_heading = get_intro_heading(get_minimum_quantity(app));

    if (heading.textContent.trim() !== intro_heading) {
      heading.textContent = intro_heading;
    }
  }

  function get_minimum_quantity(app) {
    var quantity_text = '';
    var quantity_message = app.querySelector('.wh-filter-bar span.tw-m-auto');

    if (quantity_message) {
      quantity_text = quantity_message.textContent;
    } else {
      quantity_text = app.textContent;
    }

    var minimum_match = quantity_text.match(/\(Minimum\s+(\d+)\)/i);
    if (minimum_match && minimum_match[1]) {
      return minimum_match[1];
    }

    return default_minimum_quantity;
  }

  function get_intro_heading(minimum_quantity) {
    var wine_label = minimum_quantity === '1' ? 'wine' : 'wines';
    return heading_template
      .replace(/\{minimum\}/g, minimum_quantity)
      .replace(/\{wine_label\}/g, wine_label);
  }

  function can_apply_customizations(app) {
    var review_page = app.querySelector('.wh-review-page');
    var quantity_picker = app.querySelector('.wh-global-picker');
    var selector_list = review_page ? review_required_selectors : quantity_required_selectors;
    var missing_selectors = [];

    if (!review_page && !quantity_picker && !customizations_have_started) {
      return false;
    }

    if (!review_page && !quantity_picker) {
      missing_selectors.push('.wh-global-picker or .wh-review-page');
    }

    selector_list.forEach(function (required_selector) {
      if (!app.querySelector(required_selector)) {
        missing_selectors.push(required_selector);
      }
    });

    if (missing_selectors.length === 0) {
      has_warned_about_selector_change = false;
      customizations_have_started = true;
      return true;
    }

    disable_customizations(app);

    if (!has_warned_about_selector_change) {
      console.warn(
        '[Vendemmia wine club] Custom styling has been disabled because the WineHub app markup changed or required selectors are missing.',
        {
          page: review_page ? 'review' : 'quantity',
          missing_selectors: missing_selectors
        }
      );
      has_warned_about_selector_change = true;
    }

    return false;
  }

  function disable_customizations(app) {
    document.body.classList.remove('vendemmia-customizations-ready');
    document.body.classList.remove('vendemmia-review-active');

    app.classList.remove('vendemmia-enhanced');
    app.classList.remove('vendemmia-review-active');

    var inserted_elements = app.querySelectorAll(
      '.vendemmia-visual-filters, ' +
      '.vendemmia-app-intro, ' +
      '.vendemmia-feature-description, ' +
      '.vendemmia-feature-list, ' +
      '.vendemmia-review-intro, ' +
      '.vendemmia-delivery-row, ' +
      '.vendemmia-review-form-title, ' +
      '.vendemmia-review-form-intro, ' +
      '.vendemmia-date-helper, ' +
      '.vendemmia-next-note'
    );

    inserted_elements.forEach(function (element) {
      element.remove();
    });

    app.querySelectorAll('.vendemmia-feature-card').forEach(function (card) {
      card.classList.remove('vendemmia-feature-card');
    });

    app.querySelectorAll('.vendemmia-feature-logo').forEach(function (logo_image) {
      if (logo_image.dataset.originalSrc) {
        logo_image.setAttribute('src', logo_image.dataset.originalSrc);
      } else {
        logo_image.removeAttribute('src');
      }

      if (logo_image.dataset.originalSrcset) {
        logo_image.setAttribute('srcset', logo_image.dataset.originalSrcset);
      } else {
        logo_image.removeAttribute('srcset');
      }

      if (logo_image.dataset.originalSizes) {
        logo_image.setAttribute('sizes', logo_image.dataset.originalSizes);
      } else {
        logo_image.removeAttribute('sizes');
      }

      if (logo_image.dataset.originalAlt) {
        logo_image.setAttribute('alt', logo_image.dataset.originalAlt);
      } else {
        logo_image.removeAttribute('alt');
      }

      logo_image.classList.remove('vendemmia-feature-logo');
      delete logo_image.dataset.originalSrc;
      delete logo_image.dataset.originalSrcset;
      delete logo_image.dataset.originalSizes;
      delete logo_image.dataset.originalAlt;
    });

    app.querySelectorAll('.vendemmia-review-actions, .vendemmia-order-total-row, .vendemmia-staff-toggle, .vendemmia-staff-field').forEach(function (element) {
      element.classList.remove('vendemmia-review-actions');
      element.classList.remove('vendemmia-order-total-row');
      element.classList.remove('vendemmia-staff-toggle');
      element.classList.remove('vendemmia-staff-field');
    });

    app.querySelectorAll('.vendemmia-review-wine-image-frame').forEach(function (image_frame) {
      var image = image_frame.querySelector('img');
      if (image) {
        image_frame.parentNode.insertBefore(image, image_frame);
      }

      image_frame.remove();
    });

    app.querySelectorAll('.vendemmia-review-wine-item').forEach(function (wine_item) {
      wine_item.classList.remove('vendemmia-review-wine-item');
    });

    app.querySelectorAll('.vendemmia-review-wine-image').forEach(function (wine_image) {
      wine_image.classList.remove('vendemmia-review-wine-image');
    });

    app.querySelectorAll('.wh-product-card-content-title[data-original-title], .tw-font-semibold[data-original-title]').forEach(function (title_element) {
      title_element.textContent = title_element.dataset.originalTitle;
      title_element.removeAttribute('title');
      delete title_element.dataset.originalTitle;
    });

    var popup = document.querySelector('#newsletter-popup-newsletter-popup');
    if (popup) {
      popup.classList.remove('vendemmia-popup-is-hidden');
    }
  }

  function fix_hidden_newsletter_popup() {
    var popup = document.querySelector('#newsletter-popup-newsletter-popup');
    if (!popup) {
      return;
    }

    var popup_style = window.getComputedStyle(popup);
    var is_hidden = popup_style.visibility === 'hidden' || popup_style.opacity === '0';

    popup.classList.toggle('vendemmia-popup-is-hidden', is_hidden);
  }

  function suppress_newsletter_popup() {
    var popups = document.querySelectorAll('.newsletter-popup');
    if (popups.length === 0) {
      return;
    }

    popups.forEach(function (popup) {
      popup.classList.add('vendemmia-newsletter-suppressed');
      popup.classList.remove('newsletter-popup--visible');
      popup.setAttribute('aria-hidden', 'true');
    });

    var age_checker = document.querySelector('#age-checker');
    var age_checker_visible = false;

    if (age_checker) {
      age_checker_visible = window.getComputedStyle(age_checker).display !== 'none';
    }

    if (!age_checker_visible) {
      document.body.classList.remove('overflow-hidden');
    }
  }

  function enhance_review_page(app) {
    var review_page = app.querySelector('.wh-review-page');
    if (!review_page) {
      document.body.classList.remove('vendemmia-review-active');
      app.classList.remove('vendemmia-review-active');
      return;
    }

    document.body.classList.add('vendemmia-review-active');
    app.classList.add('vendemmia-review-active');

    var review_title = review_page.querySelector('.wh-review-order');
    var intro = review_page.querySelector('.vendemmia-review-intro');
    if (review_title && !intro) {
      intro = document.createElement('p');
      intro.className = 'vendemmia-review-intro';
      review_title.insertAdjacentElement('afterend', intro);
    }

    if (intro && intro.textContent.trim() !== review_intro) {
      intro.textContent = review_intro;
    }

    var club_row = review_page.querySelector('.wh-review-retail');
    if (club_row && club_row.children.length > 1) {
      var club_label = club_row.children[0];
      var club_value = club_row.children[1];

      if (!club_row.dataset.originalText) {
        club_row.dataset.originalText = club_row.textContent.trim();
      }

      if (club_label.textContent.trim() !== 'Club') {
        club_label.textContent = 'Club';
      }

      if (club_value.textContent.trim() !== 'Vendemmia') {
        club_value.textContent = 'Vendemmia';
      }
    }

    var wine_items = [];
    var wine_heading = review_page.querySelector('.wh-review-wines');
    var wine_sibling = wine_heading ? wine_heading.nextElementSibling : null;

    while (wine_sibling) {
      if (wine_sibling.tagName === 'BR') {
        break;
      }

      var wine_row = wine_sibling.matches('.tw-flex') ? wine_sibling : wine_sibling.querySelector('.tw-flex');
      if (wine_row && wine_row.querySelector('img')) {
        wine_items.push(wine_row);
      } else if (wine_items.length > 0) {
        break;
      }

      wine_sibling = wine_sibling.nextElementSibling;
    }

    if (wine_items.length === 0) {
      wine_items = Array.prototype.slice.call(review_page.querySelectorAll('.wh-review-wines + div > div'));
    }

    wine_items.forEach(function (wine_item) {
      wine_item.classList.add('vendemmia-review-wine-item');

      var wine_image = wine_item.querySelector('img');
      if (wine_image) {
        wine_image.classList.add('vendemmia-review-wine-image');

        var image_parent = wine_image.parentElement;
        if (image_parent && !image_parent.classList.contains('vendemmia-review-wine-image-frame')) {
          var image_frame = document.createElement('span');
          image_frame.className = 'vendemmia-review-wine-image-frame';
          wine_image.parentNode.insertBefore(image_frame, wine_image);
          image_frame.appendChild(wine_image);
        }
      }
    });

    var wine_names = review_page.querySelectorAll('.vendemmia-review-wine-item .tw-font-semibold');
    wine_names.forEach(function (wine_name) {
      var text = wine_name.textContent.trim();
      var pipe_index = text.indexOf('|');

      if (!wine_name.dataset.originalTitle) {
        wine_name.dataset.originalTitle = text;
        wine_name.setAttribute('title', text);
      }

      if (pipe_index > -1) {
        wine_name.textContent = text.slice(0, pipe_index).trim();
      }
    });

    var discount_row = review_page.querySelector('.wh-frequency-discount-checkout');
    if (discount_row && !review_page.querySelector('.vendemmia-delivery-row')) {
      var delivery_row = document.createElement('div');
      delivery_row.className = 'tw-flex tw-justify-between vendemmia-delivery-row';
      delivery_row.innerHTML = '<span>Delivery</span><span>Free within Australia</span>';
      discount_row.insertAdjacentElement('afterend', delivery_row);
    }

    var summary_rows = review_page.querySelectorAll('.tw-flex.tw-justify-between');
    summary_rows.forEach(function (row) {
      var first_span = row.querySelector('span:first-child');
      if (first_span && first_span.textContent.trim().toLowerCase() === 'order total') {
        row.classList.add('vendemmia-order-total-row');
      }
    });

    var meta_fields = review_page.querySelector('.wh-meta-checkout-fields');
    if (meta_fields) {
      var form_title = meta_fields.querySelector('.vendemmia-review-form-title');
      var form_intro = meta_fields.querySelector('.vendemmia-review-form-intro');

      if (!form_title) {
        form_title = document.createElement('span');
        form_title.className = 'vendemmia-review-form-title';
        form_title.textContent = 'A couple of things before you continue';
        meta_fields.insertBefore(form_title, meta_fields.firstChild);
      }

      if (!form_intro) {
        form_intro = document.createElement('div');
        form_intro.className = 'vendemmia-review-form-intro';
        form_title.insertAdjacentElement('afterend', form_intro);
      }

      set_html_if_changed(form_intro, review_form_intro);
    }

    var date_input = meta_fields ? meta_fields.querySelector('input[type="date"]') : null;
    if (date_input && !meta_fields.querySelector('.vendemmia-date-helper')) {
      var date_helper = document.createElement('p');
      date_helper.className = 'vendemmia-date-helper';
      date_helper.textContent = 'Required by Australian law for alcohol purchases. Your voucher will be sent around your birthday each year.';
      date_input.parentNode.insertAdjacentElement('afterend', date_helper);
    }

    enhance_staff_selector(review_page, meta_fields);

    var checkout_button = review_page.querySelector('.wh-button-primary');
    var checkout_actions = checkout_button ? checkout_button.parentNode : null;
    if (checkout_actions) {
      checkout_actions.classList.add('vendemmia-review-actions');

      if (!review_page.querySelector('.vendemmia-next-note')) {
        var next_note = document.createElement('p');
        next_note.className = 'vendemmia-next-note';
        next_note.innerHTML = '<strong>Next:</strong> You will be taken to a secure checkout page to enter your full delivery address and payment details.';
        checkout_actions.insertAdjacentElement('beforebegin', next_note);
      }
    }
  }

  function enhance_staff_selector(review_page, meta_fields) {
    if (!meta_fields) {
      return;
    }

    var staff_select = get_staff_select(review_page);
    var account_button = get_staff_toggle(meta_fields);

    if (account_button) {
      account_button.classList.add('vendemmia-staff-toggle');

      if (!staff_select && meta_fields.dataset.vendemmiaStaffOpened !== 'true') {
        meta_fields.dataset.vendemmiaStaffOpened = 'true';
        account_button.click();
        staff_select = get_staff_select(review_page);
      }
    }

    if (!staff_select) {
      return;
    }

    var staff_field = staff_select.closest('label, div, p, span') || staff_select.parentElement;
    if (staff_field) {
      staff_field.classList.add('vendemmia-staff-field');
    }

    var label = find_staff_label(review_page, staff_select);
    if (label && label.textContent.trim() !== staff_label) {
      label.textContent = staff_label;
    }
  }

  function get_staff_toggle(meta_fields) {
    var delivery_input = meta_fields.querySelector('textarea');
    var sibling = delivery_input ? delivery_input.parentElement.nextElementSibling : null;

    if (sibling && sibling.tagName === 'BUTTON') {
      return sibling;
    }

    return null;
  }

  function get_staff_select(review_page) {
    var selects = review_page.querySelectorAll('select');
    var staff_select = null;

    selects.forEach(function (select) {
      var select_text = select.textContent.toLowerCase();
      var select_label = '';

      if (select.previousElementSibling) {
        select_label = select.previousElementSibling.textContent.toLowerCase();
      }

      if (select_text.indexOf('staff') > -1 || select_label.indexOf('staff') > -1) {
        staff_select = select;
      }
    });

    return staff_select;
  }

  function find_staff_label(review_page, staff_select) {
    var previous_element = staff_select.previousElementSibling;
    if (previous_element && previous_element.textContent.trim()) {
      return previous_element;
    }

    var field = staff_select.parentElement;
    if (field && field.previousElementSibling && field.previousElementSibling.textContent.trim()) {
      return field.previousElementSibling;
    }

    var labels = review_page.querySelectorAll('span, label, p');
    var staff_label_element = null;

    labels.forEach(function (label) {
      if (label.textContent.trim().toLowerCase() === 'select staff') {
        staff_label_element = label;
      }
    });

    return staff_label_element;
  }

  function start_wine_club_enhancement() {
    enhance_wine_club();

    var observer = new MutationObserver(function () {
      enhance_wine_club();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start_wine_club_enhancement);
  } else {
    start_wine_club_enhancement();
  }
})();
